import { Menu } from "antd";
import { BiHome } from "react-icons/bi";
import { BsChat } from "react-icons/bs";
import { RiFileList3Line } from "react-icons/ri";
import { HiOutlineCalculator } from "react-icons/hi";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "./styles";
import { useAuth } from "../../contexts/AuthContext";
import { ZendeskAPI } from "../ZendeskWidget/Zendesk";
import { useSideBar } from "../../contexts/SideBarContext";

export const TabNavigator = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { forceUpdateTabNavigator } = useAuth();
  const { chatNotificationQtt, setChatNotificationQtt } = useSideBar();

  const [activeKey, setActiveKey] = useState<string>("");

  const menuItems = useMemo(
    () => [
      {
        key: "/mynt/crypto",
        label: "Início",
        icon: <BiHome />,
      },
      {
        key: "/mynt/crypto-darf",
        label: "Calculadora",
        icon: <HiOutlineCalculator className="no-fill" />,
      },
      {
        key: "/mynt/cripto-report",
        label: "Informes",
        icon: <RiFileList3Line />,
      },
      {
        key: "chat",
        label: (
          <>
            Chat
            {chatNotificationQtt > 0 && (
              <span className="zendesk-chat-notification-qtt app-sidebar">
                {chatNotificationQtt}
              </span>
            )}
          </>
        ),
        icon: <BsChat />,
      },
    ],
    [chatNotificationQtt]
  );

  useEffect(() => {
    if (pathname === "/mynt/crypto") {
      setActiveKey(pathname);
    } else {
      const matchItem = menuItems
        .filter((item) => item.key !== "/mynt/crypto")
        .find(
          (item) =>
            (item.key.includes("exterior") &&
              pathname.includes("transferencia-custodia")) ||
            pathname.includes(item.key)
        );
      setActiveKey(matchItem?.key || "");
    }
  }, [pathname, menuItems, forceUpdateTabNavigator]);

  return (
    <Container>
      <Menu
        mode="horizontal"
        disabledOverflow
        activeKey={activeKey}
        selectedKeys={[activeKey]}
        onClick={(e) => {
          setActiveKey(e.key);
          if (e.key === "chat") {
            // ZendeskAPI("messenger", "open");
            document.getElementById("chat-gpt-button")?.click();
            setChatNotificationQtt(0);
          } else {
            ZendeskAPI("messenger", "close");
            navigate(e.key);
          }
        }}
      >
        {menuItems.map((item) => (
          <Menu.Item key={item.key} icon={item.icon}>
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
      <span className="hidden">{forceUpdateTabNavigator}</span>
    </Container>
  );
};
